import qz from "qz-tray";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { zebraPrintModel } from "../ZebraPrintModel";

export const printLabel = async (zplLabel: string): Promise<void> => {
  try {
    if (zebraPrintModel.device === undefined) return;

    const config = qz.configs.create(zebraPrintModel.device);
    await qz.print(config, [zplLabel]);

    console.log("Zebra printer printed");
    
  } catch (error: unknown) {
    appFaultModel.catchAppError("ZebraPrintModel.printLabel", { zplLabel }, error);
  }
};
